module.exports = __webpack_public_path__ + "static/img/liveing(6).4ae0582c.png";